"use client";

import dayjs from "@dayjs";
import { useLocale } from "next-intl";
import { ReactNode, useEffect } from "react";

type Props = {
  children: ReactNode;
};

export const ClientLocale = ({ children }: Props) => {
  const locale = useLocale();

  useEffect(() => {
    dayjs.locale(locale.toLowerCase());
  }, [locale]);

  return <div>{children}</div>;
};
